import { render, staticRenderFns } from "./tradeDetail.vue?vue&type=template&id=6c2aee0c&scoped=true&"
import script from "./tradeDetail.vue?vue&type=script&lang=ts&"
export * from "./tradeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./tradeDetail.vue?vue&type=style&index=0&id=6c2aee0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2aee0c",
  null
  
)

export default component.exports